import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import GeneralInfoService from '@/services/SettingsServices/GeneralInfoService';
import { extractError } from '@/helpers/extractApiError';

const model = {
    data: null,
    submitting: false,
    errors: null,
    successOnCreate: '',
    loading: false,
};

export const getGeneralInfo = createAsyncThunk(
    'generalInfo/getGeneralInfo',
    async (_, { rejectWithValue }) => {
        try {
            const response = await GeneralInfoService.getGeneralInfo();
            return response.data;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

export const addGeneralInfo = createAsyncThunk(
    'generalInfo/addGeneralInfo',
    async (data, { rejectWithValue }) => {
        try {
            const response = await GeneralInfoService.addGeneralInfo(data);
            return response.data;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

const generalInfoSlice = createSlice({
    name: 'generalInfo',
    initialState: model,
    reducers: {
        resetGeneralInfoStateOnError: (state) => {
            state.errors = null;
        },
        resetGeneralInfoStateOnSuccess: (state) => {
            state.successOnCreate = '';
        },
    },
    extraReducers: (builder) => {
        // get general info config
        builder.addCase(getGeneralInfo.pending, (state) => {
            state.loading = true;
        }).addCase(getGeneralInfo.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        }).addCase(getGeneralInfo.rejected, (state) => {
            state.loading = false;
        });

        // add general info config
        builder.addCase(addGeneralInfo.pending, (state) => {
            state.submitting = true;
        }).addCase(addGeneralInfo.fulfilled, (state) => {
            state.submitting = false;
            state.successOnCreate = 'General info configuration added successfully!';
        }).addCase(addGeneralInfo.rejected, (state, action) => {
            state.submitting = false;
            state.errors = action.payload;
        });
    },
});

export const {
    resetGeneralInfoStateOnError,
    resetGeneralInfoStateOnSuccess,
} = generalInfoSlice.actions;

export default generalInfoSlice.reducer;
